var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgKpmgLoadBalanceError(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 90.161,
    height: 71.811,
    viewBox: "0 0 90.161 71.811"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".kpmg-load-balance-error_svg__cls-3{fill:none;stroke:#fff;stroke-width:1.6px;stroke-linecap:round}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "kpmg-load-balance-error_svg__ICN_Modal_info_respingere_balanta_Enabled",
    "data-name": "ICN_Modal info respingere balanta_Enabled",
    transform: "translate(-383 -1523)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "kpmg-load-balance-error_svg__ICN_Modal_confirmare_Sterge_calcul",
    "data-name": "ICN_Modal confirmare Sterge calcul",
    transform: "translate(-559.92 1126.611)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "kpmg-load-balance-error_svg__Path_948",
    d: "M44.5 13.39a4 4 0 016.929 0l41.11 63.81a4 4 0 01-3.465 6H6.926a4 4 0 01-3.465-6z",
    "data-name": "Path 948",
    transform: "translate(940 385)",
    fill: "#e00744"
  }), /*#__PURE__*/React.createElement("g", {
    id: "kpmg-load-balance-error_svg__Group_2232",
    "data-name": "Group 2232",
    transform: "translate(982.262 434.343)",
    opacity: 0.804
  }, /*#__PURE__*/React.createElement("path", {
    id: "kpmg-load-balance-error_svg__Line_78",
    d: "M0 0h11.693",
    className: "kpmg-load-balance-error_svg__cls-3",
    "data-name": "Line 78",
    transform: "translate(0 17.546)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "kpmg-load-balance-error_svg__Group_701",
    "data-name": "Group 701",
    transform: "translate(0 -1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "kpmg-load-balance-error_svg__Line_79",
    d: "M0 0v12.7",
    className: "kpmg-load-balance-error_svg__cls-3",
    "data-name": "Line 79",
    transform: "translate(5.846)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "kpmg-load-balance-error_svg__Line_80",
    d: "M5.846 0L0 5.846",
    className: "kpmg-load-balance-error_svg__cls-3",
    "data-name": "Line 80"
  }), /*#__PURE__*/React.createElement("path", {
    id: "kpmg-load-balance-error_svg__Line_81",
    d: "M0 0l5.846 5.846",
    className: "kpmg-load-balance-error_svg__cls-3",
    "data-name": "Line 81",
    transform: "translate(5.846)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "kpmg-load-balance-error_svg__Ellipse_208",
    "data-name": "Ellipse 208",
    transform: "translate(971.92 426.389)",
    stroke: "#fff",
    strokeWidth: 1.6,
    fill: "none"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 15.2
  })), /*#__PURE__*/React.createElement("path", {
    id: "kpmg-load-balance-error_svg__Line_579",
    d: "M0 0v29",
    className: "kpmg-load-balance-error_svg__cls-3",
    "data-name": "Line 579",
    transform: "rotate(45 -22.298 1421.573)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "kpmg-load-balance-error_svg__Line_580",
    d: "M995.42 432.889l-18 18",
    "data-name": "Line 580",
    stroke: "#e00744",
    strokeWidth: 1.9,
    strokeLinecap: "round",
    fill: "none"
  })))));
}

export default SvgKpmgLoadBalanceError;